import { useTranslation } from "react-i18next";
import { useServices } from "@/services-context.tsx";
import { useLayoutType, LayoutTypes, LayoutStyleTypes } from "@/util-react/layout.tsx";
import { FixButton } from "@/elements-react/fix-button";
import img404 from "@/assets/img_404.svg";
import style from "./not-found-default.module.scss";
import classNames from "classnames";
import { CategoriesPreviewCustom } from "@/elements-react/categories-preview-custom";
import { PageSectionLayout } from "@/elements-react/page-section-layout";
import { CATEGORIES_LISTENER_NAME } from "@/services/categories.ts";

export function useNotFoundCommon() {
  const { t } = useTranslation();
  const { layoutType, defaultLayoutStyleType } = useLayoutType();
  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;

  const renderNavigator = () => {
    const { categories } = useServices([CATEGORIES_LISTENER_NAME]);
    const topLevelCategories = categories.findTopLevelCategories().map(({ id }) => {
      const { level, image, ...rest } = categories.getItem(id);
      return {
        ...rest,
        image: image ?? null,
        level: level != null ? String(level) : null,
      };
    });
    return <CategoriesPreviewCustom type={defaultLayoutStyleType} categories={topLevelCategories} />;
  };

  const renderContent = () => {
    return (
      <div className={isMobile ? style[LayoutStyleTypes.TYPE_SM] : ""}>
        <div className={classNames(style.errorContent)}>
          <div>
            <img src={img404} alt="404" className={style.mainImg} />
          </div>

          <h1 className={classNames(style.title)}>
            <span>{t("ufed3df90savu7d0.404-not-found-title-oops", "Oops!")}</span>
            {!isMobile && <span className={classNames(style.whitespace)}> </span>}
            {isMobile && <br />}
            <span>{t("k38vnm5jc68wvjds.404-not-found-title", "This page is gone")}</span>
          </h1>
          <span className={classNames(style.description)}>
            {t("gs7890dfg6sa34ji.404-not-found-description", "Maybe you typed in the wrong address or used an old link")}
          </span>
          <FixButton href="/" variant="primary" size="default">
            {t("vo48ckjl5bwl3h5n.back-to-home", "Go to home page")}
          </FixButton>
        </div>

        <PageSectionLayout type={defaultLayoutStyleType}>
          <div className={style.categories}>
            <span className={classNames(style.additional)}>
              {t("7cxv987sd45vb0fg.404-not-found-additional", "But you can still find the products you need")}
            </span>
            {renderNavigator()}
          </div>
        </PageSectionLayout>
      </div>
    );
  };

  return {
    renderContent,
  };
}
